import Layout from '../../components/Layout';

const Terms = () => {
  return (
    <Layout className="lg:h-screen lg:flex items-center lg:pb-14">
      <div className="max-w-lg max-h-96 overflow-y-scroll mx-auto px-2">
        <h1>Terms and Conditions</h1>
        <br />
        <p>
          Thank you for visiting the AVANT website, www.avant.com (“Site”) owned
          and operated by Chapter 4 Corp. (d/b/a Avant) (“Avant”, “us” or “we”).
          You should not access this Site or use our services until you have
          carefully read and agreed to these terms and conditions of use (the
          “Terms”) which govern your access to and use of this Site. These Terms
          apply to all Site visitors’ access to and use of the Site.
        </p>
        <br />
        <p>
          By accessing or using this Site, you agree to be bound by these Terms.
          If you do not agree to these Terms, you may not access or use this
          Site. We reserve the right, at our sole discretion, to change, modify
          or otherwise alter these Terms at any time. Such changes and/or
          modifications shall become effective immediately upon the posting
          thereof. Please review these Terms periodically. Your continued use of
          the Site following the posting of changes and/or modifications will
          constitute your acceptance of the revised Terms and the reasonableness
          of these standards for notice of changes. For this reason, we
          encourage you to review these Terms whenever you use this Site.
        </p>
        <br />
        <p>
          The Site is intended for users who are at least 13 years of age. If
          you are under the age of 13, you may not, under any circumstances or
          for any reason, use the Site or the services offered on the Site.
        </p>
      </div>
    </Layout>
  );
};

export default Terms;
